import store from '../store/index'
import { logToConsole } from './index'

class SocketsClass {
  static _instance = null
  socket = null // GLOBAL SOCKET VARIABLE
  socketSet = false // INFO ABOUT WHETHER SOCKET IS SET OR NOT
  socketRoomName = null // SOCKET ROOM USER CONNECTS TO AT START OF SESSION

  static getInstance() {
    if (!SocketsClass._instance) {
      SocketsClass._instance = new SocketsClass()
    }
    return SocketsClass._instance
  }

  setValues({ socket, socketSet, socketRoomName }) {
    if (socket) {
      this.socket = socket
    }
    if (socketSet) {
      this.socketSet = socketSet
    }
    if (socketRoomName) {
      this.socketRoomName = socketRoomName
    }
  }

  getValues() {
    return {
      socket: this.socket,
      socketSet: this.socketSet,
      socketRoomName: this.socketRoomName,
    }
  }

  reset() {
    this.socket = null
    this.socketSet = false
    this.socketRoomName = null
  }
}

export default SocketsClass
